var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C17.0752 0 22 4.92479 22 11C22 17.0752 17.0752 22 11 22C4.92479 22 0 17.0752 0 11C0 4.92479 4.92479 0 11 0ZM14.7945 15.4839C14.9967 14.8633 15.945 8.67625 16.0618 7.45708C16.0971 7.08767 15.9807 6.84246 15.752 6.73292C15.4756 6.6 15.0663 6.66646 14.591 6.83788C13.9397 7.07254 5.61229 10.6086 5.13104 10.813C4.675 11.0069 4.24325 11.2182 4.24325 11.5243C4.24325 11.7398 4.37113 11.8608 4.72313 11.9863C5.08933 12.117 6.01196 12.3965 6.55692 12.5469C7.08171 12.6917 7.67892 12.5661 8.0135 12.358C8.36825 12.1376 12.4639 9.39721 12.7577 9.15704C13.0515 8.91687 13.2857 9.22442 13.0455 9.46504C12.8054 9.70521 9.99442 12.4337 9.62363 12.8113C9.17354 13.2701 9.493 13.7454 9.79504 13.9356C10.1397 14.1529 12.6198 15.8162 12.9933 16.0829C13.3668 16.3497 13.7454 16.4707 14.0924 16.4707C14.4393 16.4707 14.6217 16.0142 14.7945 15.4839Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg2);
export default __webpack_public_path__ + "static/media/tg-2.a1a3230e2228a8f1de666ba2f9ae92af.svg";
export { ForwardRef as ReactComponent };